// extracted by mini-css-extract-plugin
export default {"button":"styles_button__fzK5E","ant-btn-disabled":"styles_ant-btn-disabled__RMJ-R","modal":"styles_modal__R8vDN"};